import { Component } from '@angular/core';

@Component({
  selector: 'app-content-box',
  styles: [
    `
      :host {
        padding: 15px;
        margin-top: 30px;
        margin-bottom: 20px;
        min-height: 600px;
        background: #fff;
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media (min-width: 992px) {
          box-shadow: 0 4px 20px rgba(87, 147, 206, 0.15);
          border-radius: 16px;
          padding: 40px;
        }

        @media (min-width: 900px) {
          width: 800px;
          padding: 40px 180px;
        }
      }
    `,
  ],
  template: '<ng-content></ng-content>',
})
export class ContentBoxComponent {}
